import { createContext } from 'react'

const SubscriptionContext = createContext()

export default SubscriptionContext
